// File: frontend/src/components/SectionSubnav.js
// Version: 1.0 (quick-260908-pun, окно 1)
// Date: 2026-09-08
// Назначение: полоса подраздела для арендатора fitenko.
//
// 🔴 ЭТО И ЕСТЬ ДОСТИЖИМОСТЬ СВЁРНУТОГО. Меню сведено с 20 пунктов в 9 разделов;
//    пункт раздела ведёт на ПЕРВОЕ ВИДИМОЕ назначение, а все остальные назначения
//    того же раздела живут здесь. Без этой полосы сведение стало бы удалением
//    страниц: Tasks, My Portal, Doc Generator, Voice AI, AI Staff, Brain Center,
//    Organic SEO, SEO Analytics, Users, Audit Log, Company Profile и Magic Deploy
//    потеряли бы единственный вход.
//
// 🔴 Своих меток компонент НЕ содержит: держатель меток ОДИН — модель навигации.

import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useBranding } from '../context/BrandingContext';
import { useUiLanguage } from '../context/UiLanguageContext';
import { subnavFor } from '../config/fitenkoNav';
import { SUBNAV_ICONS } from '../config/subnavIcons';

const SectionSubnav = () => {
    const { user, navLinks, isAuthenticated, loading } = useAuth();
    const { isFitenko, features } = useBranding();
    const { t } = useUiLanguage();
    const isRail = isFitenko || features?.shell === 'rail';
    const location = useLocation();

    if (!isRail) return null;   // РУБЕЖ АРЕНДАТОРА
    if (loading || !isAuthenticated) return null;

    const items = subnavFor(user, navLinks, location.pathname, features);
    // Пустой список — полосы НЕТ, а не пустая полоса.
    if (!items || items.length === 0) return null;

    return (
        <nav className="section-subnav bg-card text-foreground border-b border-border">
            {items.map(item => {
                const IconComponent = SUBNAV_ICONS[item.key];
                return (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        className={({ isActive }) => `section-subnav-item text-foreground hover:bg-muted ${isActive ? 'active nav-item--active' : ''}`}
                    >
                        <span className="section-subnav-item-icon inline-flex items-center">
                            {IconComponent ? <IconComponent size={15} strokeWidth={2} className="inline-block shrink-0" aria-hidden="true" /> : item.icon}
                        </span>
                        {t(`shell.dest.${item.key}`, item.label)}
                    </NavLink>
                );
            })}
        </nav>
    );
};

export default SectionSubnav;
